import React from 'react';
import styled from "styled-components";
import useStore from '../Store';
const MainDiv=styled.div`
    margin-top: 20px;
    width: 15%;
    height: 80%;
    background: #019A32;
    border-radius: 10px 10px 0 0;
    margin-left: 10px;
    
    //border: solid 1px green;
    @media (max-width: ${props=>props.ScreenWidth}) {    
        display: flex ;
        width: 100%;
        height: 5%;
        margin-bottom: 10px;
    }
`
const MenuItem=styled.div`
    
    margin-top: 5px;
    cursor: pointer;
    //border-radius: 10px;
    //margin-left: 10px;
    //margin-right: 10px;
    margin-bottom: 5px;
    padding: 5px;

    font-family: "Segoe UI";
    //font-weight: 400;
    font-style: Regular;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 100%;
    text-align: center; 
   
    
    color: white;
    //background: white;

    &:hover
    {
        background-color: lightblue;
        color: white;
    }
    
`
const SelectedMenuItem=styled(MenuItem)`
    background-color:blue;
    color:white;
`

const PagesMenu = ({selectedPage, setSelectedPage, setSelectedSubpage}) => {
    const Pages=useStore((state)=>state.PagesData)
    const Language=useStore((state)=>state.Language);
    const Languages=useStore((state)=>state.Languages);
    const ScreenWidthForMobile=useStore((state)=>state.ScreenWidthForMobile)
    function setPage(event){
        // console.log(event.currentTarget.id)
        setSelectedPage(event.currentTarget.id)
        setSelectedSubpage(false);
        if(event.currentTarget.id === "Subsidiary") setSelectedSubpage("Show subsidiaries")
    }

    return (
        <MainDiv
            ScreenWidth={ScreenWidthForMobile}
        >
            {
                Object.keys(Pages).map((element)=>{
                    if(element === selectedPage)
                        return (
                            <SelectedMenuItem
                                id={element}
                                key={element}
                                onClick={setPage}
                            >
                                {Pages[element][Languages[Language]]}
                            </SelectedMenuItem>
                        )
                    return (
                        <MenuItem
                            id={element}
                            key={element}
                            onClick={setPage}
                        >
                            {Pages[element][Languages[Language]]}
                        </MenuItem>
                    )
                })
            }
        </MainDiv>
    );
};

export default PagesMenu;